module.exports = __webpack_public_path__ + "static/img/14.7c64d46.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/14.jpg
// module id = 9+Fd
// module chunks = 1